import { Api } from "@/core/api.js";
const api = new Api();

// initial state
const state = {
  user: {},
  exp: -1,
  notifications: {},
  login: null,
  userLoadStatus: 0,
  users: {},
  selected_user: false,
  currentUserValidatingExternal: false,
  errorValidatingExternalLogin: false,
};

// getters
const getters = {
  getSession(state) {
    return { user: state.user, exp: state.exp, login: state.login };
  },
  /*
          Returns the user load status.
      */
  getUserLoadStatus(state) {
    return function() {
      return state.userLoadStatus;
    };
  },

  getNotifications(state) {
    return state.notifications;
  },

  getUser(state) {
    return state.user;
  },

  isAdmin(state) {
    return state.user.admin;
  },

  isPartner(state) {
    return parseInt(state.user.type) == 6;
  },

  getType(state) {
    return state.user.type;
  },

  getUsers(state) {
    return state.users;
  },

  getUserSelected(state) {
    return state.selected_user;
  },

  getCurrentUserValidatingExternal(state) {
    return state.currentUserValidatingExternal;
  }
};

const actions = {
  loadLocationUsers({ commit }) {
    return api.get("location/user").then(function(data) {
      if (data.status) {
        for (var key in data.data) {
          data.data[key].active =
            data.data[key].active == "0" ? "false" : "true";
        }
        return commit("setUsers", data.data);
      }
    });
  },

  loadUsers({ commit }, user_selected) {
    return api.get("user").then(function(data) {
      if (data.status) {
        return commit("setUsers", data.data, user_selected);
      }
    });
  },

  loadNotifications({ commit }) {
    return api.get("user/notifications").then(function(data) {
      if (data.status) {
        return commit("setNotifications", data.data);
      }
    });
  },

  updateNotifications: ({ commit, dispatch }, notifications) => {
    return api
      .post("user/notifications/update", {
        notifications: JSON.stringify(notifications)
      })
      .then(function(data) {
        if (data.status) {
          return commit("setNotifications", data.data);
        }
      });
  },

  uploadUser: ({ commit, dispatch }, user) => {
    var locations = user.locations;
    var sLocations = "";
    locations.forEach(location => {
      if (sLocations != "") sLocations += ",";
      sLocations += location.id;
    });

    user.locations = sLocations;

    var path = user.id == -1 ? "add" : user.id + "/update";
    return api.post("user/" + path, user).then(function(data) {
      if (data.status) {
        data.data.available = true;
        return commit("addUser", data.data);
      }
    });
  },

  uploadLocationUsers: ({ commit, dispatch }, user) => {
    var locations = user.locations;
    var sLocations = "";
    locations.forEach(location => {
      if (sLocations != "") sLocations += ",";
      sLocations += location.id;
    });

    user.locations = sLocations;

    var path = user.id == -1 ? "add" : user.id + "/update";
    return api.post("location/user/" + path, user).then(function(data) {
      if (data.status) {
        data.data.available = true;
        return commit("addUser", data.data);
      } else {
        user.locations = locations;
        return false;
      }
    });
  },

  acceptLegal: ({ commit, dispatch }, id) => {
    return api.get("user/" + id + "/legal").then(function(data) {});
  },

  removeUser: ({ commit, dispatch }, id) => {
    return api.get("user/" + id + "/delete").then(function(data) {
      if (data.status) {
        return commit("removeUser", id);
      }
    });
  },

  addPhone: ({ commit }, user) => {
    return api.post("user/addPhone", user).then(function(data) {
      if (data.status) {
        commit('updatePhone', user.phone);
      }
      return data;
    });
  },

  processExternalLogin: ({ commit, dispatch }, encodedId) => {
    return api.post('login/external', { user_id: encodedId }).then(function(data) {
      if (data.status) {
        commit('setAuthenticate', {
          user: data.data.user,
          exp: data.data.exp
        });
        
        if (data.data.restaurants) {
          commit('locations/setRestaurants', data.data.restaurants, { root: true });
        }
        if (data.data.sliders) {
          commit('setSliders', data.data.sliders, { root: true });
        }
        
        return api.get('restaurant/getMenu').then(menuData => {
          if (menuData.status) {
            commit('locations/setMenu', menuData.data, { root: true });
          }
          return data;
        });
      }
      return data;
    });
  },

  doLogout({ commit }) {
    api.get("logout").then(function(data) {
      commit("setAuthenticate", false);
      commit("setOverlayVisible", false);
      commit("setUserMenuVisible", false);
      router.replace({ name: "login" });
    });
  },
};
const mutations = {
  setAuthenticate(state, data) {
    if (!data) {
      state = {
        user: {},
        exp: -1,
        login: null,
        userLoadStatus: 0
      };
    } else {
      state.user = data.user;
      state.user.letter = data.user.name.substring(0, 1).toUpperCase();
      state.exp = data.exp;
      state.login = moment();
      state.userLoadStatus = 2;
    }
    return true;
  },

  logoutUser(state) {
    state = {
      user: {},
      exp: -1,
      login: null,
      userLoadStatus: 0,
      users: {}
    };
  },

  setUsers(state, data, user_selected) {
    if (!data) {
      state.users = {};
    } else {
      state.users = data;

      if (typeof user_selected !== "undefined") {
        state.selected_user = data[user_selected];
      }
    }
  },

  setNotifications(state, data) {
    if (!data || Object.values(data).length == 0) {
      //   DEFAULT NOTIFICATIONS OBJECT
      state.notifications = { newFiles: true };
    } else {
      state.notifications = data;
    }
  },

  setSelectedUser(state, data) {
    state.selected_user = data;
  },

  setSelectedUserByID(state, id) {
    if (typeof state.users[id] !== "undefined") {
      state.selected_user = state.users[id];
    } else {
      state.selected_user = false;
    }
  },

  addUser(state, user) {
    var users = { ...state.users };

    users[user.id] = user;

    state.users = users;
  },

  removeUser(state, id) {
    var users = { ...state.users };

    delete users[id];

    state.users = users;
  },

  updatePhone(state, phone) {
    if (state.user) {
      state.user.phone = phone;
    }
  },

  setCurrentUserValidatingExternal(state, userId) {
    state.currentUserValidatingExternal = userId;
  },

  setErrorValidatingExternalLogin(state, value) {
    state.errorValidatingExternalLogin = value;
  },
  
  setCallLoginUsers(state, value) {
    // Ensure value is either 0 or 1
    state.callLoginUsers = value === 1 ? 1 : 0;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
